module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-4.2bee2f13.svg";